<div class="{$$props.class} p-4 rounded-xl m-2">
	<slot />
</div>
